module.exports = __webpack_public_path__ + "static/img/2.a7b8f486.jpg";